// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "电力系统自动化",
      "tec": "白迪",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    {
      "sub": "电网规划与设计",
      "tec": "魏子康",
      "week": "1-8周",
      "add": "教学楼A座321电力"
    },
    {
      "sub": "电气CAD",
      "tec": "孙震敖",
      "week": "1-8周",
      "add": "实训楼C座103"
    },
    0
  ],
  "2": [
    0,
    {
      "sub": "二次回路",
      "tec": "高鑫家",
      "week": "1-8周",
      "add": "教学楼C座310教务"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "电力系统自动化",
      "tec": "白迪",
      "week": "1,3,5,7周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "电网规划与设计",
      "tec": "魏子康",
      "week": "2,4,6,8周",
      "add": "教学楼C座307教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "二次回路",
      "tec": "高鑫家",
      "week": "1-8周",
      "add": "教学楼A座117电力"
    },
    {
      "sub": "配电自动化",
      "tec": "孙震敖",
      "week": "1-8周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "电气CAD",
      "tec": "孙震敖",
      "week": "1-8周",
      "add": "实训楼C座103"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
